import { Component, OnInit, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ResultsService, ResultMoment } from 'src/app/services/results.service';
import { ILayerViewLayer } from 'src/app/model/api-services/layer-views.service';
import { MapService } from 'src/app/services/map.service';
import { SLLayer } from 'src/app/model/sl-layer';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { UUID } from 'angular2-uuid';


export interface IGalleryItem {
  id: string;
  moment: ResultMoment;
  expanded: boolean;
  isLatest: boolean;
}

export interface ViewRequest {
  name: string;
  data: Array<ILayerViewLayer>;
  moment: ResultMoment;
}

@Component({
  selector: 'app-layer-gallery',
  templateUrl: './layer-gallery.component.html',
  styleUrls: ['./layer-gallery.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayerGalleryComponent implements OnInit {

  private _ready = false;
  public listReady = false;
  public synchReady = true;
  public listing: Array<IGalleryItem> = [];
  public viewRequests: EventEmitter<ViewRequest> = new EventEmitter<ViewRequest>();

  constructor(
    private resultsSvc: ResultsService,
    private mapSvc: MapService,
    private messager: ModalMessagerService,
    private cdr: ChangeDetectorRef
  ) {
    this.listReady = false;
  }


  ngOnInit(): void {
    this.listReady = false;
    this.listing = [];
    for (const entry of this.resultsSvc.history.entries) {
      if (!entry) {
        continue;
      }
      const isLatest = entry.id === ((!!this.resultsSvc.history.latest) ? this.resultsSvc.history.latest.id : false);
      const item: IGalleryItem = {
        id: entry.id,
        expanded: true,
        moment: entry,
        isLatest: (isLatest)
      }
      this.listing.push(item);
    }
    this.listReady = true;
    this.resultsSvc.history.synchSetChange.toPromise().then(
      (status) => {
        switch (status) {
          case 'changing':
            this.listReady = false;
            break;
          case 'changed':
            this.listReady = true;
            break;
        }
        this.resultsSvc.history.UpdateMomentSyncs();
        this._ready = true;
        this.Refresh();

      }
    );
    this.resultsSvc.history.UpdateMomentSyncs();
    this._ready = true;
    this.Refresh();

  }

  AddItem(item: IGalleryItem) {
    if (!item.moment) return;
    if (!this.resultsSvc?.history) return;
    // this.listReady = false;
    const moment: ResultMoment = this.resultsSvc.history.UpsertClone(item.moment);

    const newItem: IGalleryItem = {
      id: UUID.UUID(),
      expanded: (moment.id === this.resultsSvc.history.latest.id),
      moment: (moment),
      isLatest: (moment.id === this.resultsSvc.history.latest.id)
    }
    this.listing.push(newItem);
    // this.listReady = true;
  }
  RemoveItem(item: IGalleryItem) {
    this.listReady = false;
    this.messager.Confirm(
      'Removing this entry from the gallery cannot be undone, click ok to remove, or cancel to abort.',
      () => {
        this.resultsSvc.history.RemoveAMoment(item.moment);
        const i = this.listing.indexOf(item);
        this.listing.splice(i, 1);
      },
      null,
      'Delete confirmation'
    );
    this.listReady = true;
  }
  TextAreaAutoHeight(textArea: HTMLTextAreaElement) {
    textArea.style.height = '5px';
    textArea.style.height = (15 + textArea.scrollHeight) + 'px';
  }
  ShowLayers(item: IGalleryItem) {
    this.viewRequests.emit({
      name: 'layers',
      data: this.MomentToLayerViewLayers(item.moment),
      moment: item.moment
    })
  }
  ShowGroupings(item: IGalleryItem) {
    this.viewRequests.emit({
      name: 'groupings',
      data: this.MomentToLayerViewLayers(item.moment),
      moment: item.moment
    })
  }
  MomentToLayerViewLayers(moment: ResultMoment): Array<ILayerViewLayer> {
    const layers: Array<ILayerViewLayer> = [];
    const map = this.mapSvc.GetMap();
    let allTrue = false;
    if (!(!!moment.resultSet.displayedLayers)) {
      moment.resultSet.displayedLayers = {};
      allTrue = true;
    }
    for (const result of moment.resultSet.results) {
      const slLayer: SLLayer = map.GetLayerById('' + result.layer);
      result.display = (result.hasOwnProperty('display')) ? result.display : true;
      layers.push(slLayer);
      if (allTrue) {
        moment.resultSet.displayedLayers[slLayer.id] = true;
      }
    }
    return layers;
  }
  HandleListSynch(item: IGalleryItem, isOn: boolean) {
    this.resultsSvc.Synch({
      channel: this.resultsSvc.history.synchSet['results-list'],
      data: { moment: item.moment },
      source: 'results-gallery',
      topic: 'synch-data',
      synchFrom: 'results-gallery',
      synchTo: 'results-list'

    });
    this.resultsSvc.history.UpdateMomentSyncs();
    this.UpdateList();
  }
  SynchTo(item: IGalleryItem, target: 'popup-control' | 'results-list' | 'info') {
    this.resultsSvc.Synch({
      channel: this.resultsSvc.history.synchSet[target],
      data: { moment: item.moment },
      source: 'results-gallery',
      topic: 'synch-data',
      synchFrom: 'results-gallery',
      synchTo: target
    });
    this.resultsSvc.history.UpdateMomentSyncs();
    this.Refresh();
  }
  IsSynched(item: IGalleryItem, target: string): boolean {
    return item.moment.synchs[target] === true
  }
  GetButtonMode(item: IGalleryItem, target: string): 'secondary' | 'primary' {
    return this.IsSynched(item, target) ? 'secondary' : 'primary'
  }
  UpdateList() {
    if (!this._ready) return;
    if (this.listReady === false) return;
    this.listReady = false;
    this.Refresh();
    this.listReady = true;
    this.Refresh();
  }
  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }
}
